module.exports = __webpack_public_path__ + "img/FC_Template_Retired.9b1f22d4.png";